import { useEffect, useState } from 'react'

/**
 * A lazy thumbnail for lists and grids (plan smartkraal-owner-experience B1):
 * `glyph` shows underneath while the image loads and stays when the variant is
 * not built yet (the API answers 404 until the nightly pass runs). It never
 * swaps in the multi-megabyte original the way a single hero image may; it
 * tells its owner through `onFail` instead, so a lightbox opened from it can
 * ask for the original. Sizing and shape come from `className`.
 */
export default function MediaThumb({ src, alt = '', className = '', imgClassName = 'object-cover', glyph = null, onFail, style }) {
  const [failed, setFailed] = useState(false)
  useEffect(() => { setFailed(false) }, [src])
  return (
    <span className={`relative block overflow-hidden ${className}`} style={style}>
      {glyph && <span className="absolute inset-0 flex items-center justify-center">{glyph}</span>}
      {src && !failed && (
        <img src={src} alt={alt} loading="lazy" decoding="async"
             className={`absolute inset-0 h-full w-full ${imgClassName}`}
             onError={() => { setFailed(true); if (onFail) onFail() }} />
      )}
    </span>
  )
}
